const QUESTION_TITLE_APPLICABLE_UPDATE_TYPES = [
  'Bulk order request',
  'Reorder request',
  'Requesting premade sample',
  'Requesting sample',
  'Need support',
  'Order request',
  'RFQ support'
];

// Must match backend/updates/models.py > CUSTOMER_CTA_TEMPLATES, the values
// backend/clarifications/serializers.py > ClarificationCreationSerializer accepts
// as tracking_event_id
const CTA_BULK_ORDERING = 'cta_bulk_order';
const CTA_REORDER = 'cta_reorder';
const CTA_BUY_PRE_MADE_SAMPLE = 'cta_buy_pre_made_sample';
const CTA_REQUEST_NEW_SAMPLE = 'cta_request_new_sample';
const CTA_SUPPORT = 'cta_support';
const CTA_RFQ_SUPPORT = 'cta_rfq_support';

/** Update message template id of a customer call-to-action. */
type CtaTemplateId =
  | typeof CTA_BULK_ORDERING
  | typeof CTA_REORDER
  | typeof CTA_BUY_PRE_MADE_SAMPLE
  | typeof CTA_REQUEST_NEW_SAMPLE
  | typeof CTA_SUPPORT
  | typeof CTA_RFQ_SUPPORT;

export {
  CTA_BULK_ORDERING,
  CTA_BUY_PRE_MADE_SAMPLE,
  CTA_REORDER,
  CTA_REQUEST_NEW_SAMPLE,
  CTA_SUPPORT,
  QUESTION_TITLE_APPLICABLE_UPDATE_TYPES,
  CTA_RFQ_SUPPORT
};
export type { CtaTemplateId };
